// extracted by mini-css-extract-plugin
export default {"container":"headline_container__El4XX","headline1":"headline_headline1__DjDGI","headline3":"headline_headline3__Yv6ND","headline2":"headline_headline2__W8B1h"};